import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { AuditLogPage } from '@/features/admin';
import { workspaceSearchSchema } from '@/patterns';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/admin/audit-log')({
  validateSearch: workspaceSearchSchema.extend({ entity: zSearchText() }),
  staticData: { crumb: 'admin:nav.audit' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.audit', 'Setup'),
  component: function AuditLog() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <AuditLogPage search={search} onSearchChange={(patch, o) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false })} />;
  },
});
